module.exports = __webpack_public_path__ + "img/金隅嘉华大厦 拷贝.af53a66b.png";